import { Outlet, RouteObject } from 'react-router-dom';
import { lazyImport } from 'shared/routing/LazyRoute';

const LockAccountPage = lazyImport(
  () => import('./LockAccountPages'),
  'LockAccountPage',
);
const LockedAccountPage = lazyImport(
  () => import('./LockAccountPages'),
  'LockedAccountPage',
);

export const lockAccountRoutes: RouteObject[] = [
  {
    path: '/lock-account',
    element: <Outlet />,
    children: [
      {
        path: 'locked',
        element: <LockedAccountPage />,
      },
      {
        path: ':id?',
        element: <LockAccountPage />,
      },
    ],
  },
];
